import { render, staticRenderFns } from "./SysMsgEdit.vue?vue&type=template&id=02a0c288&scoped=true"
import script from "./SysMsgEdit.vue?vue&type=script&lang=js"
export * from "./SysMsgEdit.vue?vue&type=script&lang=js"
import style0 from "./SysMsgEdit.vue?vue&type=style&index=0&id=02a0c288&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02a0c288",
  null
  
)

export default component.exports